import { DEFAULT_INTEGRATION_STATE } from '../slices/integrationsSlice';

const selectIntegrationsRoot = (state) => state.integrations;

const selectIntegrationsMap = (state) => selectIntegrationsRoot(state).integrations || {};

export const selectIntegrationById = (id) => (state) =>
  selectIntegrationsMap(state)[id] || DEFAULT_INTEGRATION_STATE;

// Slack selectors
export const selectSlackIntegration = (state) => selectIntegrationById('slack')(state);

export const selectSlackAvailable = (state) =>
  selectSlackIntegration(state).available || false;

export const selectSlackChannels = (state) =>
  selectSlackIntegration(state).channels || [];

// MS Teams selectors
export const selectMsteamsIntegration = (state) =>
  selectIntegrationById('msteams')(state);

export const selectMsteamsAvailable = (state) =>
  selectMsteamsIntegration(state).available || false;

export const selectMsteamsChannels = (state) =>
  selectMsteamsIntegration(state).channels || [];

export const selectMsteamsInstances = (state) =>
  selectMsteamsIntegration(state).instances || [];

export const selectMsteamsActiveInstanceId = (state) =>
  selectMsteamsIntegration(state).activeInstanceId || null;

// Jira selectors
export const selectJiraIntegration = (state) =>
  selectIntegrationById('jira')(state);

export const selectJiraAvailable = (state) =>
  selectJiraIntegration(state).available || false;

export const selectJiraConfig = (state) =>
  selectJiraIntegration(state).meta?.config || null;
